var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Small_Icons",
    "data-name": "Small Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 3px;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_20",
    "data-name": "Rounded Rectangle 20",
    className: "cls-1",
    d: "M24.333,3.48h2.334a5.52,5.52,0,1,1,0,11.04H24.333A5.52,5.52,0,1,1,24.333,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_20_copy",
    "data-name": "Rounded Rectangle 20 copy",
    className: "cls-1",
    d: "M23.99,19.493H27.01a5.507,5.507,0,1,1,0,11.013H23.99A5.507,5.507,0,0,1,23.99,19.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_20_copy_2",
    "data-name": "Rounded Rectangle 20 copy 2",
    className: "cls-1",
    d: "M23.867,35.493h3.267a5.507,5.507,0,1,1,0,11.013H23.867A5.507,5.507,0,1,1,23.867,35.493Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_20_copy_3",
    "data-name": "Rounded Rectangle 20 copy 3",
    className: "cls-2",
    x: 19,
    y: 36,
    width: 13,
    height: 11,
    rx: 5.5,
    ry: 5.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticle);
export default __webpack_public_path__ + "static/media/verticle.15d5892d188013611df7ab02081ec0bc.svg";
export { ForwardRef as ReactComponent };